/**
 * Which shell a screen is wearing.
 *
 * `pjazza` is the directory and the account — the app's own chrome, with a live
 * wordmark and a route to Places. `venue` is a menu, where the wordmark goes
 * inert and the chrome names the venue and the table instead: a route out of a
 * restaurant to a list of its competitors is the half of the silence rule still
 * standing. `bare` is the scanner, which is a full-screen camera and nothing.
 *
 * Declared once because two files answer it — the layout decides, the header
 * renders — and the layout's set has one member more than the header's.
 */
const PJ_APP_CONTEXT = {
  PJAZZA: 'pjazza',
  VENUE: 'venue',
  BARE: 'bare'
} as const

type PjAppContext = (typeof PJ_APP_CONTEXT)[keyof typeof PJ_APP_CONTEXT]

/** Everything the header renders. It is never mounted on the bare scanner. */
type PjChromeContext = Exclude<PjAppContext, typeof PJ_APP_CONTEXT.BARE>

/** The header's slot for a page's search. The header renders it; a page teleports into it. */
const PJ_HEADER_SEARCH_ID = 'pj-header-search'

/**
 * The server's skeleton of a venue page, which stands in until the app has drawn
 * it. resources/views/pjazza/venue-skeleton.blade.php paints it with this id as a
 * literal; main.ts removes it after the first render.
 */
const PJ_SKELETON_ID = 'pj-skeleton'

export { PJ_APP_CONTEXT, PJ_HEADER_SEARCH_ID, PJ_SKELETON_ID }
export type { PjAppContext, PjChromeContext }
